import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';
import { Shield, Lock, ArrowRight, Loader2, Mail } from 'lucide-react';
import { GlassButton } from '../components/ui/GlassButton';

export const AdminLogin: React.FC = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [loading, setLoading] = useState(false);
    const [error, setError] = useState('');
    const { login } = useAuth();
    const navigate = useNavigate();

    const handleSubmit = async (e: React.FormEvent) => {
        e.preventDefault();
        setLoading(true);
        setError('');
        try {
            await login(email, password, true);
            navigate('/banana');
        } catch (err: any) {
            setError('Acesso negado. Apenas administradores autorizados.');
        } finally {
            setLoading(false);
        }
    };

    return (
        <div className="auth-page min-h-screen flex items-center justify-center p-4 bg-[#050505]">
            <div className="auth-card w-full max-w-md bg-orange-500/5 border border-orange-500/10 rounded-[32px] p-10 backdrop-blur-3xl relative overflow-hidden">
                {/* Intense Admin Glow */}
                <div className="absolute top-[-50%] left-[50%] -translate-x-1/2 w-96 h-96 bg-orange-600/20 rounded-full blur-[100px] pointer-events-none" />

                <div className="relative z-10">
                    <div className="text-center mb-10">
                        <div className="w-16 h-16 bg-orange-500/10 border border-orange-500/20 rounded-2xl flex items-center justify-center mx-auto mb-6">
                            <Shield className="text-orange-500" size={32} />
                        </div>
                        <h1 className="text-2xl font-bold text-white mb-2 uppercase tracking-widest">Master Access</h1>
                        <p className="text-gray-500 text-xs font-mono uppercase">Restricted Area - Hotlize Protocol</p>
                    </div>

                    {error && (
                        <div className="bg-red-500/10 border border-red-500/20 text-red-500 p-4 rounded-xl mb-6 text-xs text-center font-bold">
                            {error.toUpperCase()}
                        </div>
                    )}

                    <form onSubmit={handleSubmit} className="space-y-6">
                        <div className="input-group-pro admin-input">
                            <label className="text-orange-500/50">ADMIN IDENTIFIER</label>
                            <div className="input-wrapper border-orange-500/20 bg-orange-500/5">
                                <Mail size={18} className="text-orange-500/50" />
                                <input
                                    type="email"
                                    placeholder="admin@hotlize.com"
                                    value={email}
                                    onChange={e => setEmail(e.target.value)}
                                    className="placeholder:text-orange-900/40 text-orange-100"
                                    required
                                />
                            </div>
                        </div>

                        <div className="input-group-pro admin-input">
                            <label className="text-orange-500/50">SECURITY KEY</label>
                            <div className="input-wrapper border-orange-500/20 bg-orange-500/5">
                                <Lock size={18} className="text-orange-500/50" />
                                <input
                                    type="password"
                                    placeholder="••••••••"
                                    value={password}
                                    onChange={e => setPassword(e.target.value)}
                                    className="placeholder:text-orange-900/40 text-orange-100"
                                    required
                                />
                            </div>
                        </div>

                        <GlassButton
                            type="submit"
                            className="w-full h-14 mt-4"
                            loading={loading}
                        >
                            {loading ? <Loader2 className="animate-spin" /> : <>AUTHORIZE ACCESS <ArrowRight size={18} /></>}
                        </GlassButton>
                    </form>

                    <p className="mt-8 text-center text-[10px] text-gray-700 font-mono tracking-tighter">
                        SECURITY LOGS ARE BEING RECORDED. UNAUTHORIZED ATTEMPTS WILL RESULT IN PERMANENT IP BAN.
                    </p>
                </div>
            </div>
        </div>
    );
};
